import { SvgIcon, SvgIconProps } from "@mui/material";

export const BlockQuotesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M10 16.002h6.003M10 12h8.003M10 7.998h6.003M5.5 4v16"
      />
    </svg>
  </SvgIcon>
);
